import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import ITAndCyberBackgroundImageBlockData from 'app/Models/Content/ITAndCyberBackgroundImageBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import React from 'react';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';
import TagName from 'app/Components/Shared/TagName';

const ITAndCyberBackgroundImageBlock = ({data, context}: ComponentProps<ITAndCyberBackgroundImageBlockData>) => {
  return (
    <div className='ITAndCyberBackgroundImageBlock' {...getBackgroundImageProps(isMobile ? data.mobileImage : data.titleAsImage, context)}>
      <div className='ITAndCyberBackgroundImageBlock__title-subtitle-and-button'>
        {!isMobile && data.desktopTitle.expandedValue
          ? data.desktopTitle.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
              <TagName
                tagName={data.titleHeadlineTag?.value}
                isTitle
                key={i}
                className='ITAndCyberBackgroundImageBlock__title-subtitle-and-button__title'>
                {getTextWithHighlight({text: text.value, highlightText: highlightText.value})}
              </TagName>
            ))
          : data.title.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
              <TagName
                tagName={data.titleHeadlineTag?.value}
                isTitle
                key={i}
                className='ITAndCyberBackgroundImageBlock__title-subtitle-and-button__title'>
                {getTextWithHighlight({text: text.value, highlightText: highlightText.value})}
              </TagName>
            ))}

        <TagName tagName={data.subtitleHeadlineTag?.value} className='ITAndCyberBackgroundImageBlock__title-subtitle-and-button__subtitle'>
          {!isMobile && data.desktopSubtitle?.value ? data.desktopSubtitle.value : data.subtitle?.value}
        </TagName>

        <a className='ITAndCyberBackgroundImageBlock__title-subtitle-and-button__button' href={data.buttonLink.value}>
          {data.buttonLinkTitle.value}
        </a>
      </div>
    </div>
  );
};

export default ITAndCyberBackgroundImageBlock;
